<template>
<b-sidebar
right
id="download-resources" 
v-model="visibility"
shadow>
	<h4
	@click="$store.commit('download_resources/setStartDownload')">
		Descarga de recursos
	</h4>
	<p
	v-for="model in models_to_download">
		<b-spinner
		v-if="model.downloading"
		variant="primary"></b-spinner>
		<i 
		v-else-if="model.downloaded"
		class="icon-check"></i>
		<i 
		v-else-if="!model.downloaded"
		class="icon-clock"></i>
		<span>
			{{ plural(model.model_name) }}
		</span>
	</p>    
</b-sidebar>
</template>
<script>
import call_methods from '@/mixins/call_methods'
export default {
	mixins: [call_methods],
	computed: {
		visibility: {
			get() {
				return this.$store.state.download_resources.visibility
			},
			set(value) {
				// this.$store.commit('download_resources/setVisibility')
			}
		},
		start_download() {
			return this.$store.state.download_resources.start_download
		},
	},
	created() {
		setTimeout(() => {
			this.setModels()
			this.downloadModels()
		}, 1000)
	},
	watch: {
		start_download() {
			console.log('watch de start_download')
			this.setModels()
			this.downloadModels()
		}
	},
	data() {
		return {
			models_to_download: [],
		}
	},
	methods: {
		setModels() {
			// Se vacia antes de armarla: setModels() tambien corre con el boton de volver a
			// descargar, y sin esto la lista se duplicaba en cada clic.
			this.models_to_download = []
			call_methods.forEach(model => {
				this.models_to_download.push({
					downloaded: false,
					downloading: false,
					model_name: model,
				})
			})
		},
		/**
		 * Descarga los recursos del arranque.
		 *
		 * Antes esto era un `for` con `await` adentro que pedia cada modelo por su endpoint: 30
		 * requests por usuario, uno detras de otro, mas las ~7 paginas de siniestros —que encima
		 * salian en paralelo con el resto porque siniestro/getModels no devolvia la promesa—. Cada
		 * request es una conexion nueva a MySQL, y scrap-free vive en la misma cuenta de shared
		 * hosting que los ~33 clientes de ComercioCity: con los 7 usuarios entrando a la misma
		 * hora, el arranque solo eran ~260 conexiones en pocos segundos contra un servidor que
		 * todos los dias se queda sin ("Too many connections" en el log de produccion, 15/9/2026).
		 * Y el throttle de la API es de 60 requests por minuto: dos recargas seguidas daban 429.
		 *
		 * Ahora salen, en este orden y de a uno:
		 *   1. UNA llamada, POST /api/recursos-iniciales, con todos los catalogos.
		 *   2. Lo que esa llamada no supo devolver (no_soportados, con_error, o la llamada entera
		 *      si fallo), por su endpoint individual, EN SERIE. En serie y no en paralelo a
		 *      proposito: si la masiva fallo es porque el servidor esta saturado, y tirarle 30
		 *      requests juntas en ese momento es lo que este cambio viene a sacar.
		 *   3. Los modelos paginados (siniestro), que no entran en la masiva, tambien en serie:
		 *      su getModels ahora devuelve la promesa, asi que el `await` espera la ultima pagina.
		 *
		 * Lo que NO cambio: el filtrado por celular, yaSeDescargaron() antes de pedir, y que cada
		 * fila del panel se marca al terminar (tambien si fallo, para que el spinner no quede
		 * girando para siempre).
		 */
		async downloadModels() {
			/** Los que van en la llamada masiva. */
			let para_masivo = []
			/** Los que se piden por su endpoint individual (paginados). */
			let sueltos = []

			this.models_to_download.forEach(model => {
				let model_name = model.model_name
				if ((this.is_mobile && !this.downloadOnMobile(model_name)) || (model_name == 'article' && !this.downloadArticles())) {
					return
				}
				if (this.yaSeDescargaron(model_name)) {
					model.downloaded = true
					return
				}
				model.downloading = true
				if (this.esPaginado(model_name)) {
					sueltos.push(model_name)
				} else {
					para_masivo.push(model_name)
				}
			})

			if (para_masivo.length) {
				let a_replegar = await this.pedirMasivo(para_masivo)
				await this.pedirSueltos(a_replegar)
			}
			await this.pedirSueltos(sueltos)
		},
		/**
		 * Pide en UNA sola llamada todos los catalogos que el endpoint soporta y los deja en el
		 * store. Devuelve los nombres que hay que pedir igual de a uno.
		 *
		 * @param {Array} model_names
		 * @returns {Promise<Array>}
		 */
		pedirMasivo(model_names) {
			return this.$api.post('recursos-iniciales', {models: model_names})
			.then(res => {
				let respuesta = res.data ? res.data : {}
				let recibidos = respuesta.models ? respuesta.models : {}
				let a_replegar = []

				model_names.forEach(model_name => {
					let cuerpo = recibidos[model_name]
					// El backend devuelve el cuerpo tal cual lo devolvia el endpoint individual, o
					// sea {models: [...]}. Si no vino asi (no_soportados, con_error, o cualquier
					// otra cosa), se pide de a uno en vez de commitear cualquier cosa.
					if (!cuerpo || typeof cuerpo.models == 'undefined') {
						a_replegar.push(model_name)
						return
					}
					this.$store.commit(model_name + '/setModels', cuerpo.models)
					this.marcarDescargado(model_name)
				})

				if (a_replegar.length) {
					console.log('recursos-iniciales: se piden de a uno ' + a_replegar.join(', '))
				}
				return a_replegar
			})
			.catch(err => {
				// Si la llamada masiva entera se cae (red, 500, sesion vencida) no se puede dejar
				// la sesion sin catalogos: se cae al camino viejo, cada modelo por su endpoint.
				console.log('recursos-iniciales fallo, se piden todos de a uno')
				console.log(err)
				return model_names
			})
		},
		/**
		 * Pide cada modelo por su endpoint individual, uno detras de otro.
		 *
		 * @param {Array} model_names
		 * @returns {Promise}
		 */
		async pedirSueltos(model_names) {
			for (var i = 0; i < model_names.length; i++) {
				let model_name = model_names[i]
				try {
					await this.$store.dispatch(model_name + '/getModels')
				} catch (err) {
					console.log(err)
				}
				this.marcarDescargado(model_name)
			}
		},
		/**
		 * Un modelo paginado (use_per_page) no entra en la llamada masiva: su index() pagina y la
		 * SPA lo recorre pagina por pagina.
		 *
		 * @param {string} model_name
		 * @returns {boolean}
		 */
		esPaginado(model_name) {
			let store = this.$store.state[model_name]
			return !!(store && store.use_per_page)
		},
		marcarDescargado(model_name) {
			let fila = this.models_to_download.find(model => model.model_name == model_name)
			if (fila) {
				fila.downloading = false
				fila.downloaded = true
			}
		},
		yaSeDescargaron(model_name) {
			return this.$store.state[model_name].models.length 
		}
	},
}
</script>
<style lang="sass">
@import '@/sass/_custom.scss'
#download-resources
	@if ($theme == 'dark') 
		background: #333 !important
	padding: 20px
	h4 	
		margin: 15px 0
	p 
		text-align: left
		display: flex 
		align-items: center 
		.spinner-border 
			width: 20px
			height: 20px
		span 
			padding-left: 10px
</style>